module.exports = __webpack_public_path__ + "img/85a841a.png";